export function saveLogId(newLogId) {
  let logId = window.sessionStorage.getItem("unique-id");

  if (!logId || !window.name) {
    logId = newLogId;
    window.sessionStorage.setItem("unique-id", logId);
  }

  window.name = logId;
  return logId;
}
export function generateUuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
